import type { FC, ReactNode } from 'react'
import type { GetStaticPaths, GetStaticProps } from 'next'

import ToolPage from '@/components/tools/tool-page'
import GuidePage from '@/components/tools/guide-page'
import { TOOLS, findTool } from '@/constants/tools'
import { GUIDES, findGuide } from '@/constants/guides'

interface SlugPageProps {
    kind: 'tool' | 'guide'
    slug: string
}

export const getStaticPaths: GetStaticPaths = async () => ({
    paths: [...TOOLS, ...GUIDES].map((item) => ({ params: { slug: item.slug } })),
    fallback: false
})

export const getStaticProps: GetStaticProps<SlugPageProps> = async ({ params }) => {
    const slug = String(params?.slug ?? '')

    if (findTool(slug)) return { props: { kind: 'tool', slug } }
    if (findGuide(slug)) return { props: { kind: 'guide', slug } }

    return { notFound: true }
}

const SlugPage: FC<SlugPageProps> = ({ kind, slug }): ReactNode => {
    if (kind === 'tool') {
        const tool = findTool(slug)
        return tool ? <ToolPage tool={tool} /> : null
    }

    const guide = findGuide(slug)
    return guide ? <GuidePage guide={guide} /> : null
}

export default SlugPage
